import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { useIncidentLogTypesField } from "./IncidentLogTypesField.hooks.ts";

export interface IncidentLogTypesFieldProps {
    types: Array<string>;
    onTypesChange: (types: Array<string>) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogTypesField(props: IncidentLogTypesFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, incidentTypes } = useIncidentLogTypesField(props.isPreview);

    return (
        <DotLegalMultiSelect
            options={incidentTypes}
            isLoading={isLoading}
            chosenOptions={props.types}
            onChange={props.onTypesChange}
            label={translateString("type")}
            placeholder={translateString("incidentTypeDropdown")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogTypesField;
